const state = {
    all: new Array()
};
const getters = {
    tags(state) {
        return state.all;
    }
};
const actions = {
    initializeClient({ commit }, clientId) {
        window.App.$axios.get(`/api/audience/api/v1.0/companyid/${clientId}/audience/tags?api_user=${window.eInsightUserEmail}`)
            .then((response) => {
            const tags = new Array();
            response.data.data.forEach((value) => {
                tags.push({ text: value.name });
            });
            commit('setTags', { tags });
        })
            .catch((xhr) => {
            /// TODO: Handle failed API call
            console.log('Tag Store => failed to load tags from API', xhr);
        }).then(() => {
            // setting to True even if failed
            window.InitializationWatcher.tagsLoaded = true;
        });
    },
    // storeClientTags({ commit }, tags: Tag[]) {
    //    console.log(`store/tag => storeClientTags`, tags);
    //    state.all = tags;
    // },
    addTag({ commit }, data) {
        commit('addTag', data);
    },
};
const mutations = {
    addTag(state, data) {
        state.all.push(data.newTag);
    },
    setTags(state, data) {
        state.all = data.tags;
    }
};
export const tag = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
//# sourceMappingURL=index.js.map